import { useBookingRoute } from "@/components/hooks/use-booking-route";
import { LuceSparkle } from "@/components/shared/icons";
import { Button, View } from "@/components/ui";

import { BottomDrawerModal } from "../../bottom-drawer-modal";
import { Typography } from "../../typography";

export const DeepCleaningDisclaimerModal = ({
  isOpen,
  onAcknowledge,
}: {
  isOpen: boolean;
  onAcknowledge: () => void;
}) => {
  const { forward } = useBookingRoute();
  const handleClick = () => {
    onAcknowledge();
    forward();
  };

  return (
    <BottomDrawerModal open={isOpen} onOpenChange={onAcknowledge}>
      <View className="flex flex-1 flex-col px-2">
        <Typography variant="label-md">Deep Cleaning Disclaimer</Typography>
        <Description label="By proceeding with this booking, you acknowledge and agree to the following:" />
        <DeepCleaningDisclaimerList label="The Deep Cleaning service is scheduled for 4 hours, with the number of cleaners assigned based on your selected house size and an average home condition." />
        <DeepCleaningDisclaimerList label="If the property is found to have heavy stains, excessive dirt, clutter, or debris, the team may decline, reschedule, or adjust the service accordingly." />
        <DeepCleaningDisclaimerList label="For special requests or specific areas requiring extra attention, please contact our Sales Team prior to booking." />
        <DeepCleaningDisclaimerList label="Please ensure that you have selected the correct house size, as the team and cleaning duration will be arranged strictly according to your chosen option." />
        <Description label="By clicking “Acknowledge”, you confirm that you have read, understood, and agreed to the above Deep Cleaning Disclaimer." />
      </View>
      <View className="flex flex-col px-2 pt-4">
        <Button
          children="Acknowledge"
          variant="primary"
          color="CTA"
          onClick={handleClick}
        />
      </View>
    </BottomDrawerModal>
  );
};

const DeepCleaningDisclaimerList = ({ label }: { label: string }) => {
  return (
    <View className="flex flex-1 flex-row items-center gap-4 border-b border-secondary-border py-3 md:py-4">
      <LuceSparkle className="size-6 max-w-[24px] text-brand-primary" />
      <View className="flex flex-1">
        <Typography variant="label-sm">{label}</Typography>
      </View>
    </View>
  );
};

const Description = ({ label }: { label: string }) => {
  return (
    <View className="flex flex-row items-center gap-4 border-b border-secondary-border py-3 md:py-4">
      <Typography variant="body-md">{label}</Typography>
    </View>
  );
};
